import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const icons = {
  success: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="9" r="9" fill="#4bc800" fillOpacity="0.15"/>
      <path d="M5 9l3 3 5-5" stroke="#1a5c30" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  danger: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="9" r="9" fill="#fee2e2"/>
      <path d="M6 6l6 6M12 6l-6 6" stroke="#dc2626" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
  warning: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="9" r="9" fill="#fef3c7"/>
      <path d="M9 6v4M9 12v.5" stroke="#d97706" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),
};

const Alert = ({ alerts }) =>
  alerts !== null && alerts.length > 0 ? (
    <div className="ti-toast-container">
      {alerts.map((alert) => (
        <div key={alert.id} className={`ti-toast ti-toast--${alert.alertType}`}>
          <span className="ti-toast-icon">{icons[alert.alertType] || icons.success}</span>
          <span className="ti-toast-msg">{alert.msg}</span>
        </div>
      ))}
    </div>
  ) : null;

Alert.propTypes = {
  alerts: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  alerts: state.alert,
});

export default connect(mapStateToProps)(Alert);
